"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateTemplateShiftType = exports.LaborClassStatus = exports.CostCodeStatus = exports.CostCodeCategories = void 0;
var CostCodeCategories;
(function (CostCodeCategories) {
    CostCodeCategories["LABOR"] = "LABOR";
    CostCodeCategories["OVERHEAD_LABOR"] = "OVERHEAD_LABOR";
    CostCodeCategories["MATERIALS"] = "MATERIALS";
    CostCodeCategories["EQUIPMENT"] = "EQUIPMENT";
    CostCodeCategories["SUBCONTRACTORS"] = "SUBCONTRACTORS";
    CostCodeCategories["OVERHEAD"] = "OVERHEAD";
    CostCodeCategories["OTHER"] = "OTHER";
})(CostCodeCategories = exports.CostCodeCategories || (exports.CostCodeCategories = {}));
var CostCodeStatus;
(function (CostCodeStatus) {
    CostCodeStatus["ACTIVE"] = "ACTIVE";
    CostCodeStatus["DEACTIVATED"] = "DEACTIVATED";
})(CostCodeStatus = exports.CostCodeStatus || (exports.CostCodeStatus = {}));
var LaborClassStatus;
(function (LaborClassStatus) {
    LaborClassStatus["ACTIVE"] = "ACTIVE";
    LaborClassStatus["DEACTIVATED"] = "DEACTIVATED";
})(LaborClassStatus = exports.LaborClassStatus || (exports.LaborClassStatus = {}));
var RateTemplateShiftType;
(function (RateTemplateShiftType) {
    RateTemplateShiftType["DOLLAR"] = "DOLLAR";
    RateTemplateShiftType["PERCENTAGE"] = "PERCENTAGE";
})(RateTemplateShiftType = exports.RateTemplateShiftType || (exports.RateTemplateShiftType = {}));
